// src/App.js (Updated with all new routes)

import React from 'react';
import { ThemeProvider } from '@mui/material/styles'; 
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import theme from './theme'; 
import './App.css'; 

// --- Component Imports (Existing) ---
import Header from './components/Header';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import AuthCard from './components/AuthCard'; 
import HeroSection from './components/HeroSection';
import HowItWorksSection from './components/HowItWorksSection';
import ValuePropositionSection from './components/ValuePropositionSection';

// --- NEW PUBLIC PAGE IMPORTS (Header Links) ---
import HowItWorksPage from './pages/HowItWorksPage';
import TopicsPage from './pages/TopicsPage';
import ChatRoomsPage from './pages/ChatRoomsPage';
import AboutFAQPage from './pages/AboutFAQPage';

// --- NEW DASHBOARD PAGE IMPORTS (Sidebar Links) ---
import DashboardHome from './pages/DashboardHome'; 
import ProfilePage from './pages/app/ProfilePage';
import FeedPage from './pages/app/FeedPage';
import EventsPage from './pages/app/EventsPage';
import SettingsPage from './pages/app/SettingsPage';


const LandingPage = () => (
    <>
        <HeroSection />
        <HowItWorksSection />
        <ValuePropositionSection />
    </>
);

function App() {
  return (
    <ThemeProvider theme={theme}> 
      <Router>
        <div className="App">
            <Header />
            
            <Routes>
                {/* 1. PUBLIC ROUTES (Header Links) */}
                <Route path="/" element={<LandingPage />} /> 
                <Route path="/how-it-works" element={<HowItWorksPage />} />
                <Route path="/topics" element={<TopicsPage />} />
                <Route path="/chat-rooms" element={<ChatRoomsPage />} />
                <Route path="/about-faq" element={<AboutFAQPage />} />

                {/* 2. AUTH ROUTES */}
                <Route path="/login" element={<AuthCard type="login" />} />
                <Route path="/signup" element={<AuthCard type="signup" />} />

                {/* 3. DASHBOARD ROUTES (Sidebar Links) */}
                <Route path="/app/dashboard" element={<DashboardHome />} />
                <Route path="/app/profile" element={<ProfilePage />} />
                <Route path="/app/feed" element={<FeedPage />} />
                <Route path="/app/events" element={<EventsPage />} />
                <Route path="/app/settings" element={<SettingsPage />} />
                
            </Routes>
            
            <Footer /> 
            <ChatWidget />
            
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;